import React from 'react';
import { HeartHandshake } from 'lucide-react';
export function SelfHelpSection() {
  return <section id="self-help" className="py-20 md:py-28 bg-[#F5F0E8]" data-id="element-777">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-778">
        <div className="mb-12 flex flex-col items-center" data-id="element-779">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-780">
            <HeartHandshake className="w-8 h-8 text-[#D4A843]" data-id="element-781" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-782">
            Self-Help
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-783" />
        </div>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed text-left md:text-center" data-id="element-784">
          <p className="font-medium text-xl text-[#0A5E5C]" data-id="element-785">
            This section is created for those who want to better understand
            their own gambling behavior and for those who are trying to
            understand what gambling is and why it can carry risks, as well as
            for those who want to assess the possible risks of gambling and get
            practical self-control tools.
          </p>

          <p data-id="element-786">
            Gambling can be a form of entertainment and bring pleasure. However,
            sometimes, when a person loses control for certain reasons, gambling
            can start to negatively affect their finances, emotional state,
            relationships with loved ones, and quality of life.
          </p>

          <p data-id="element-787">
            Therefore, it is very important to be attentive to yourself, to your
            own emotions, feelings, reactions, and states that accompany you
            before, during, and after the game. It is very important to be in
            touch with yourself and be aware of everything that happens to you
            when you play, when you think about the game. Perhaps you use the
            game to escape from an unbearable reality that you don't like for
            some reason. Perhaps you feel incredible emotional excitement during
            the game that is nowhere else available to you in life. Perhaps you
            decided that gambling is an easy way to make money. Or perhaps all
            these thoughts and feelings are present in you at the same time. Do
            not turn away from them and do not judge yourself, show a little
            attention to yourself and if you are reading this text, then you are
            definitely capable and ready to regain control over your game and
            your life. Believe in yourself. Only you truly decide who and what
            controls you and your life, and even if, due to certain
            circumstances, you gave control over yourself to the game, or to
            something else that captured you, you can definitely take this
            control back. This is your absolute right, the right to control
            yourself and your life, and even if it seems impossible to you now,
            just at least allow such a thought and try to move forward and the
            space of life will begin to provide you with support and help on the
            way back to yourself. We believe in you and your strength.
          </p>
        </div>
      </div>
    </section>;
}